var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import './components/index.js';
import '../_common/components/button.js';
import './doc-bookmark-block.js';
import './edgeless-bookmark-block.js';
import { assertExists, Slot } from '@blocksuite/global/utils';
import { BlockElement } from '@blocksuite/lit';
import { html, render } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
import { matchFlavours } from '../_common/utils/index.js';
import { AffineDragHandleWidget } from '../page-block/widgets/drag-handle/drag-handle.js';
import { captureEventTarget, convertDragPreviewDocToEdgeless, convertDragPreviewEdgelessToDoc, } from '../page-block/widgets/drag-handle/utils.js';
import { BookmarkBlockSchema, } from './bookmark-model.js';
import { EdgelessBookmarkHeight, EdgelessBookmarkWidth, } from './edgeless-bookmark-block.js';
import { refreshBookmarkUrlData } from './utils.js';
let BookmarkBlockComponent = class BookmarkBlockComponent extends BlockElement {
    constructor() {
        super(...arguments);
        this.loading = false;
        this._isInSurface = false;
        this.slots = {
            loadingUpdated: new Slot(),
        };
        this._dragHandleOption = {
            flavour: BookmarkBlockSchema.model.flavour,
            edgeless: true,
            onDragStart: ({ state, startDragging, anchorBlockPath }) => {
                if (!anchorBlockPath)
                    return false;
                const anchorComponent = this.std.view.viewFromPath('block', anchorBlockPath);
                if (!anchorComponent ||
                    !matchFlavours(anchorComponent.model, [
                        BookmarkBlockSchema.model.flavour,
                    ]))
                    return false;
                const blockComponent = anchorComponent;
                const isInSurface = blockComponent.isInSurface;
                if (!isInSurface) {
                    this.host.selection.setGroup('block', [
                        this.host.selection.getInstance('block', {
                            path: blockComponent.path,
                        }),
                    ]);
                    startDragging([blockComponent], state);
                    return true;
                }
                const element = captureEventTarget(state.raw.target);
                const insideDragHandle = !!element?.closest('affine-drag-handle-widget');
                if (!insideDragHandle)
                    return false;
                const bookmarkPortal = blockComponent.closest('.edgeless-block-portal-bookmark');
                assertExists(bookmarkPortal);
                const dragPreviewEl = bookmarkPortal.cloneNode();
                dragPreviewEl.style.transform = '';
                render(blockComponent.host.renderModel(blockComponent.model), dragPreviewEl);
                startDragging([blockComponent], state, dragPreviewEl);
                return true;
            },
            onDragEnd: props => {
                const { state, draggingElements } = props;
                if (draggingElements.length !== 1 ||
                    !matchFlavours(draggingElements[0].model, [
                        BookmarkBlockSchema.model.flavour,
                    ]))
                    return false;
                const blockComponent = draggingElements[0];
                const isInSurface = blockComponent.isInSurface;
                const target = captureEventTarget(state.raw.target);
                const isTargetEdgelessContainer = target?.classList.contains('edgeless') &&
                    target?.classList.contains('affine-block-children-container');
                if (isInSurface) {
                    return convertDragPreviewEdgelessToDoc({
                        blockComponent,
                        ...props,
                    });
                }
                else if (isTargetEdgelessContainer) {
                    return convertDragPreviewDocToEdgeless({
                        blockComponent,
                        cssSelector: 'bookmark-card',
                        width: EdgelessBookmarkWidth.horizontal,
                        height: EdgelessBookmarkHeight.horizontal,
                        ...props,
                    });
                }
                return false;
            },
        };
    }
    get isInSurface() {
        return this._isInSurface;
    }
    connectedCallback() {
        super.connectedCallback();
        const parent = this.host.page.getParent(this.model);
        this._isInSurface = parent?.flavour === 'affine:surface';
        if (!this.model.description) {
            refreshBookmarkUrlData(this).catch(console.error);
        }
        this.disposables.add(this.model.propsUpdated.on(({ key }) => {
            this.edgelessOrDocBookmark?.requestUpdate();
            if (key === 'url') {
                refreshBookmarkUrlData(this).catch(console.error);
            }
        }));
        this.disposables.add(AffineDragHandleWidget.registerOption(this._dragHandleOption));
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has('loading')) {
            this.slots.loadingUpdated.emit();
        }
    }
    render() {
        if (this.isInSurface) {
            return html `<affine-edgeless-bookmark
        .block=${this}
      ></affine-edgeless-bookmark>`;
        }
        else {
            return html `<affine-doc-bookmark .block=${this}></affine-doc-bookmark>`;
        }
    }
};
__decorate([
    property({ attribute: false })
], BookmarkBlockComponent.prototype, "loading", void 0);
__decorate([
    query('affine-edgeless-bookmark, affine-doc-bookmark')
], BookmarkBlockComponent.prototype, "edgelessOrDocBookmark", void 0);
BookmarkBlockComponent = __decorate([
    customElement('affine-bookmark')
], BookmarkBlockComponent);
export { BookmarkBlockComponent };
//# sourceMappingURL=bookmark-block.js.map